import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FORGOT_PASSWORD_REQUEST } from '../../Utils/Constant';

const ForgotPassword = ({ onBackToLogin, onSuccess }) => {
  const dispatch = useDispatch();
  const { loading, error, forgotPasswordSuccess } = useSelector(state => state.auth);
  const [email, setEmail] = useState('');
  const emailRef = useRef(null);

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  // Watch for success state change
  useEffect(() => {
    if (forgotPasswordSuccess) {
      onSuccess && onSuccess(email);
    }
  }, [forgotPasswordSuccess, email, onSuccess]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch({ type: FORGOT_PASSWORD_REQUEST, payload: { email } });
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '1rem',
      }}
    >
      <div
        className="card shadow-lg"
        style={{
          maxWidth: 420,
          width: '100%',
          borderRadius: '1rem',
          padding: '2rem',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
        }}
      >
        <h2 className="card-title text-center mb-4 fw-bold" style={{ color: '#333' }}>
          Forgot Password
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="email" className="form-label fw-semibold">
              Email Address
            </label>
            <input
              id="email"
              type="email"
              className="form-control"
              placeholder="your.email@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              ref={emailRef}
            />
          </div>
          {error && (
            <div className="alert alert-danger py-2 mb-4 text-center" style={{ fontWeight: '500', fontSize: '0.9rem' }}>
              {error}
            </div>
          )}
          <button
            type="submit"
            className="btn w-100 py-2 fw-bold"
            disabled={loading}
            style={{
              fontSize: '1.1rem',
              borderRadius: '0.75rem',
              letterSpacing: '0.05em',
              backgroundColor: '#000',
              color: '#fff',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.4)',
              transition: 'background-color 0.3s ease',
              border: 'none',
            }}
          >
            {loading ? 'Sending...' : 'Send OTP'}
          </button>
        </form>
        <div className="mt-4 text-center">
          <button
            className="btn btn-link text-decoration-none"
            onClick={onBackToLogin}
            type="button"
            style={{ fontWeight: '600', color: '#764ba2' }}
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
